import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const SortingModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;

  .content {
    overflow-y: auto;

    .opt-group {
      padding: 0 20px 20px 20px;
      ${mixin.flex({
        direction: 'column',
        align: 'flex-start',
        justify: 'flex-start',
        wrap: 'wrap',
      })};
      row-gap: 28px;
      height: 228px;

      .og-list {
        ${mixin.flex({ justify: 'flex-start', wrap: 'wrap' })};
        gap: 6px;
      }

      .title {
        display: block;
        padding: 4px 0 12px 0;
        font-size: 13px;
        font-weight: 500;
        line-height: 130%;
        color: #999;
      }

      .radio {
        min-width: 68px;

        svg {
          display: none;
        }

        .label {
          width: 100%;
          height: 36px;
          margin: 0;
          font-size: 14px;
          line-height: 130%;
          color: #acacac;
          padding: 8px 16px 10px 16px;
          text-align: center;
          overflow: hidden;
          border-radius: 30px;
          border: 1px solid #e2e2e2;
        }
      }

      .active {
        .radio .label {
          color: #000;
          border: 1px solid #000;
        }
      }
    }

    .opt-single {
      padding: 0 20px 32px 20px;

      li {
        ${mixin.flex({ justify: 'flex-start' })};
      }

      .radio {
        align-items: center;
        width: calc(100% - 30px);
        height: 44px;

        svg {
          display: none;
        }

        .label {
          width: 100%;
          margin: 0;
          font-size: 15px;
          font-weight: 500;
          line-height: 130%;
          color: #999;
          ${mixin.flex({
            justify: 'flex-start',
            align: 'center',
            wrap: 'wrap',
          })};
          .tooltip-popup {
            top: auto;
          }
        }
      }

      svg {
        margin-left: 13px;
        width: 14px;
        height: 12px;
      }

      .active {
        .radio .label {
          color: #000;
        }
      }
    }
  }
`;
